export class SandboxAnalyticsUIUpdate {
    show = false;
    scrollTo = false;

    constructor(show = false, scrollTo = false) {
        this.show = show;
        this.scrollTo = scrollTo;
    }
}
